import styled from 'styled-components'

export const StyledWindow = styled.div`
	${({ isFullScreen, additionalStyles, theme })=> `
		
	z-index: 101;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	${isFullScreen ? `
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			max-width: ${theme.contentMaxWidth};
	` : ''}
		${additionalStyles}
`}
	`

export const StyledLabel = styled.div`
	font-size: 18px;
	padding: 8px 0 8px 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #fff;
	background-color: ${({ type, theme })=> {
		let color
		switch(type) {
			case 'alert': {
				color = theme.errorColor
				break
			}
			default: {
				color = theme.primaryColor
				break
			}
		}
		return color
	}
};
	svg {
		margin-left: auto;
		margin-right: 10px;
		cursor: pointer;
		width: 35px;
		height: 35px;
		g {
			stroke: white;
			stroke-width: 0.2;
		}
		circle {
			display: none;
		}
	`

export const StyledContent = styled.div`
		height: 100%;
		max-height: calc(100vh - 55px);
		padding: 20px;
		overflow: auto;
		background-color: ${({ theme })=>theme.darkbgColor};
		box-shadow: 0 2px 4px 0 rgba(90, 90, 90, 0.2);
		.card-content {
			// width: 400px!important;
			background-color: #efefef;
		}
		
		${({ additionalStyles })=> additionalStyles ? additionalStyles : ''}
`

export const StyledOverlay = styled.div`
	z-index: 100;
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	background: rgba(255, 255, 255, 0.9);
`

export const ProgressContainer = styled.div`
	position: absolute;
	left: 50%;
	top: calc(50% + 40px);
	width: 40%;
	transform: translateX(-50%);
	z-index: 101;
`
